<template>
  <component :is="ShippingAndReturnsBadge" />
</template>

<script setup>
import { defineAsyncComponent } from 'vue';

const ShippingAndReturnsBadge = defineAsyncComponent(() => import(
  /* webpackMode: "eager" */
  /* webpackPreload: true */
  /* webpackChunkName: "PDP_ShippingAndReturnsBadge" */
  `./ShippingAndReturnsBadge.${process.env.ENTRY_POINT}`
));
</script>
